var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverrideCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "#868686",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C10.8634 0 14 3.36062 14 7.5C14 11.6394 10.8634 15 7 15C3.13658 15 0 11.6394 0 7.5C0 3.36062 3.13658 0 7 0ZM7 0.625C10.5414 0.625 13.4167 3.70563 13.4167 7.5C13.4167 11.2944 10.5414 14.375 7 14.375C3.45858 14.375 0.583333 11.2944 0.583333 7.5C0.583333 3.70563 3.45858 0.625 7 0.625ZM11.0833 5.28562L5.83042 11.2638L2.91667 7.59812L3.36058 7.1925L5.852 10.3275L10.6587 4.8575L11.0833 5.28562Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverrideCheck);
export default __webpack_public_path__ + "static/media/override-check.443b4f18.svg";
export { ForwardRef as ReactComponent };